import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import CampaignListPresenter from "./CampaignListPresenter";
import { useLocation, useNavigate } from "react-router-dom";
import { useCampaignListAPI } from "./campaigns.api";
import { getFansNavOptions } from "../constant";
import { useConfiguration } from "src/api/configuration";
import { useContext } from "react";
import AppContext from "src/AppContext";

export default function CampaignListContainer() {
  const { pathname } = useLocation();
  const { data: config } = useConfiguration();
  const { account } = useContext(AppContext);
  const navigate = useNavigate();

  const { data: campaigns, isLoading } = useCampaignListAPI();
  const navOptions = getFansNavOptions(config?.flags ?? {}, account?.plan);

  return (
    <ContentBox>
      <Header
        title="My Fans"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />

      <SpinnerWrapper loading={isLoading}>
        <CampaignListPresenter
          campaigns={campaigns || []}
        />
      </SpinnerWrapper>
    </ContentBox>
  );
}